import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {DataService} from '../../data/data.ts';
import { ToastController } from 'ionic-angular';
import * as firebase from 'firebase';

@Component({
  templateUrl: 'build/pages/results/results.html'
})
export class ResultsPage {
  private dataService: DataService;
  public murdererGuess: Number = -1;
  public bestDressed: Number = -1;
  public bestPerformance: Number = -1;
  public callback: Function;
  private lastToast: any = null;


  constructor(private navCtrl: NavController, private toastController : ToastController, private _data: DataService) {
  	this.dataService = _data;
  	this.callback = (error) => {
      if (error) {
        this.createToastWithMessage("Unable to cast votes :( Try again.");
      } else {
        this.createToastWithMessage("Your votes have been recorded!");
      }
    }
  }
  ionViewLoaded() {
  }
  submitVotes(){
  	if (this.bestDressed < 0 || this.murdererGuess < 0 || this.bestPerformance < 0){
  		this.createToastWithMessage("You must choose someone in every category.");
  	}else{
  		this.dataService.castVotes(this.bestDressed, this.bestPerformance, this.murdererGuess, this.callback);
  	}
  }

  characterKeys() : Array<string> {
    return Object.keys(this.dataService.allCharacters);
  }

  createToastWithMessage(message){
  	if (this.lastToast != null){
  		this.lastToast.dismiss();
  	}
    let toast = this.toastController.create({
      message: message,
      duration: 3000,
      dismissOnPageChange: true,
      position: 'top'
    });
    toast.onDidDismiss(() => {
	    this.lastToast = null;
	});
    toast.present();
  }
}
